import React from 'react';
import './socials.css'

const Socials = (props) => {
    return ( <>
    <div className='sdiv'>
        <img className='socailsicon' src={props.socialsicon} alt="" />
    </div>
    </> );
}
 
export default Socials;